import { render, staticRenderFns } from "./NewsCreateOrEdit.vue?vue&type=template&id=3c02c263&"
import script from "./NewsCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./NewsCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewsCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports